import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Github, ArrowUpRight } from "lucide-react";
import LocationMap from "./LocationMap";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative border-t border-white/10 bg-[#05060A]">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4">
          <img src="/logo-light.png" alt="Growing IT Solutions" className="h-10 w-auto mb-5" />
          <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
            Best-in-class AI engineering for businesses in India and across the globe. We build
            production-grade GenAI, automation and data platforms — and stay for the long run.
          </p>
          <div className="flex gap-3 mt-6">
            <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" data-testid="footer-linkedin" className="w-9 h-9 grid place-items-center border border-white/10 hover:border-primary hover:text-primary text-slate-400 transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="https://github.com" target="_blank" rel="noreferrer" data-testid="footer-github" className="w-9 h-9 grid place-items-center border border-white/10 hover:border-primary hover:text-primary text-slate-400 transition-colors">
              <Github className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-5">Company</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="text-slate-400 hover:text-white transition-colors">About</Link></li>
            <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors">Services</Link></li>
            <li><Link to="/case-studies" className="text-slate-400 hover:text-white transition-colors">Case Studies</Link></li>
            <li><Link to="/contact" className="text-slate-400 hover:text-white transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-5">Services</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors">Generative AI & RAG</Link></li>
            <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors">AI Chatbots & Agents</Link></li>
            <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors">Workflow Automation</Link></li>
            <li><Link to="/services" className="text-slate-400 hover:text-white transition-colors">Data Engineering</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-5">Get in touch</h4>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3 text-slate-400">
              <MapPin className="w-4 h-4 mt-0.5 text-primary shrink-0" />
              <span>B521, Money Plant High Street, Jagatpur Road, Gota, 382470, Ahmedabad, Gujarat, India</span>
            </li>
            <li className="flex items-center gap-3 text-slate-400">
              <Phone className="w-4 h-4 text-primary shrink-0" />
              <a href="tel:+918799097310" className="hover:text-white transition-colors">+91 87990 97310</a>
            </li>
            <li className="flex items-center gap-3 text-slate-400">
              <Mail className="w-4 h-4 text-primary shrink-0" />
              <a href="mailto:contact@growingitsolutions.com" className="hover:text-white transition-colors">contact@growingitsolutions.com</a>
            </li>
          </ul>
          <Link to="/contact" className="inline-flex items-center gap-1.5 mt-6 text-sm font-semibold text-primary hover:gap-2.5 transition-all">
            Start a project <ArrowUpRight className="w-4 h-4" />
          </Link>
          <LocationMap height="h-40" className="mt-6 rounded-lg" />
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Growing IT Solutions. All rights reserved.</p>
          <p>We Help You Grow.</p>
        </div>
      </div>
    </footer>
  );
}
